








import { Component, Vue } from 'vue-property-decorator';
import Progress from '@/components/Progress.vue';
import Leaflets from '@/components/Leaflets.vue';
import QRCode from '@/components/QRCode.vue';
import Navbar from '@/components/Navbar.vue';

@Component({
  components: {
    Progress,
    Leaflets,
    QRCode,
    Navbar
  }
})
export default class Home extends Vue {}
